/**
 * Os parâmetros de URL que o Mapa aceita além da aba e da OP (`?op=`). Funções PURAS.
 *
 * Eles existem para um LINK de outra tela abrir a grade já recortada: a Visão executiva
 * pergunta "quando esta célula fica livre" e a resposta inteira está no Mapa, naquela
 * célula e naquela semana. Sem os parâmetros o Mapa abre exatamente como abria.
 */

/** A célula que o link quer no filtro da tela, pelo nome dela no cadastro. */
export const MAPA_CELULA_PARAM = 'celula';

/** O dia (ISO) cuja semana o detalhe abre. É um dia, e não um índice: índice não é link. */
export const MAPA_SEMANA_PARAM = 'semana';

/**
 * A janela "Cartões" aberta. Ela era um bloco das Configurações (`?bloco=mapaCartao`), e
 * aquele endereço reenvia para cá: o link que alguém já mandou abre o mesmo assunto.
 */
export const MAPA_CARTOES_PARAM = 'cartoes';
export const MAPA_CARTOES_ABERTA = 'aberta';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** O recorte de uma semana da grade que esta conta precisa: as duas pontas dela. */
interface ISemanaDoDia {
  inicio: string;
  fim: string;
}

/**
 * O índice da semana da grade que CONTÉM o dia pedido.
 *
 * A busca é pela primeira semana que termina no dia ou depois dele, e não pelo início
 * exato: o dia que chega no link é o primeiro dia útil livre da célula (uma quarta, por
 * exemplo), não a segunda-feira da semana dele.
 *
 * Dia depois da última semana do horizonte abre a ÚLTIMA janela, que é o mais perto que a
 * grade chega daquele dia. Dia ilegível, ou grade vazia, devolve `null`: aí o detalhe abre
 * onde abriria sem link nenhum, em vez de numa semana inventada.
 */
export function indiceDaSemanaDoDia(semanas: ReadonlyArray<ISemanaDoDia>, dia: string): number | null {
  if (semanas.length === 0 || !ISO_DATE.test(dia)) {
    return null;
  }
  const indice = semanas.findIndex((semana) => dia <= semana.fim);
  return indice === -1 ? semanas.length - 1 : indice;
}
